import React, { useState, useEffect, useContext, useRef } from 'react';
import {ResourceList as ResourceListShopify, Avatar, TextStyle, Stack, Link, TopBar, Icon} from '@shopify/polaris';
import {EditMinor} from '@shopify/polaris-icons';
import {SearchContext} from '@thinkwell/react.common';
import {ResourceList} from '@thinkwell/react.polaris';
import EditContent from './EditContent';
import MainFrame from '../MainFrame';
import { ContentsContext } from '../contexts/Contents'
import compact from 'lodash/compact';
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Contents(props) {
  const [contents, fetchContents, fetchContentsState] = useContext(ContentsContext);
  const [search, setSearch] = useContext(SearchContext);

  const navigateToRef = useRef()
  const [addContentActive, setAddContentActive] = useState(false);
  const [editContentItem, setEditContentItem] = useState()
  const [isContentMenuOpen, setIsContentMenuOpen] = useState(false);
  const toggleIsContentMenuOpen = () => setIsContentMenuOpen((isContentMenuOpen) => !isContentMenuOpen);

  const contentsSorted = sortBy(contents, ['name']);

  const onSearch = (params) => {
    fetchContents(`/content.json?type=${props.type}`, params)
  }

  const delayedSearch = useRef(debounce(onSearch, 1000));

  const onSearchChange = (value) => {
    setSearch(value)
    delayedSearch.current({query: value})
  }

  const contentMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Content', onAction: () => { setEditContentItem(null); setAddContentActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Contents"
       initials="P"
       open={isContentMenuOpen}
       onToggle={toggleIsContentMenuOpen}
     />
   );

  const renderContent = (item) => {
    const {name} = item;
    return (
      <ResourceListShopify.Item
        id={item.id}
        accessibilityLabel={`View details for ${name}`}
        onClick={() => navigateToRef.current(`content/${item.id}`, {withContext: true})}
        shortcutActions={[{content: <Icon source={EditMinor} />, onAction: () => { setEditContentItem(item); setAddContentActive(true) }}]}
      >
        <Stack>
          <Stack.Item fill>
            <h3>
              <TextStyle variation="strong">{name}</TextStyle>
            </h3>
          </Stack.Item>
          <Stack.Item>
            {item.updated_at ? <TextStyle variation="subdued">{formatDate(item.updated_at)}</TextStyle> : null }
          </Stack.Item>
        </Stack>
      </ResourceListShopify.Item>
    );
  };

  const onAddContent = (content) => {
    if (!editContentItem) {
      navigateToRef.current(`content/${content.id}?type=${props.type}`)
    }
  }

  return (
    <div>
    <MainFrame onSearchChange={onSearchChange} searchPlaceHolder="Search contents"
    userMenu={contentMenuMarkup} navigateToRef={navigateToRef}>
      { addContentActive ?
        <EditContent
          item={editContentItem}
          active={addContentActive}
          type={props.type}
          onActive={(active) => { if (active != addContentActive) { setAddContentActive(active) }}}
          onSave={onAddContent}
        /> :
        <ResourceList withoutSort items={contentsSorted} fetchItems={fetchContents} fetchItemsState={fetchContentsState}
        url={`/content.json?type=${props.type}`} renderItem={renderContent}
        resourceName={ {singular: 'content', plural: 'contents'} }></ResourceList>
      }
    </MainFrame>
  </div>);
}
